export const CRYSTAL_COLORS = {
  "Clear Quartz": "#d0d0d0",
  "Rose Quartz": "#f4a7b9",
  "Citrine": "#f5c842",
  "Black Tourmaline": "#3a3a3a",
  "Aquamarine": "#7ecfe0",
  "Jade": "#7fc97f",
  "Amethyst": "#9b59b6",
  "Pyrite": "#d4af37",
  "Lapis Lazuli": "#2255a4",
  "Moonstone": "#c8d8e8",
  "Tiger Eye": "#c8860a",
  "Selenite": "#f0f0e8",
  "Sunstone": "#f08030",
  "Pearl": "#e8e0c8",
  "Yellow Topaz": "#f5e040",
  "Smoky Quartz": "#8b6c42",
  "Blue Lace Agate": "#a8c8e0",
  "Green Aventurine": "#52c476",
  "Labradorite": "#5080a0",
  "Black Obsidian": "#2c2c2c",
  "Garnet": "#8b1a1a",
  "Celestite": "#b0c8e0",
  "Malachite": "#2e8b57",
  "Red Jasper": "#c0392b",
  "Emerald": "#27ae60",
  "Peridot": "#93c572",
  "Lepidolite": "#c8a0c8",
  "Obsidian": "#2c2c2c",
  "Turquoise": "#40e0d0",
  "Bloodstone": "#2d6a4f",
  "Rhodonite": "#e8a0b0",
  "Carnelian": "#e8602c",
  "Sodalite": "#4060a0",
  "Fluorite": "#9080c0",
};

export function crystalColor(name) {
  return CRYSTAL_COLORS[name] || "#c8c8c8";
}
